import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { CompanySelectorFormField } from '~components/FormFields/CompanySelectorFormField';
import { CompanyBasic } from '~hooks/useCompany/models';

import CompanyExportRendererToggles from './CompanyExportRendererToggles';

const selectedCompanySchema = yup.object().shape({
  company: yup.mixed<CompanyBasic>().nullable(),
});
type SelectedCompanyDTO = yup.InferType<typeof selectedCompanySchema>;

export default function ExportRenderers() {
  const form = useForm<SelectedCompanyDTO>({
    resolver: yupResolver(selectedCompanySchema),
    mode: 'onSubmit',
    defaultValues: { company: null },
  });

  const companyId = form.watch('company')?.id ?? null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <CompanySelectorFormField
        clearable
        control={form.control}
        errors={form.formState.errors}
        hideLabel
        inputProps={{ placeholder: `${t('form_fields.company_selector_hint')}` }}
        name="company"
        sx={{ width: '540px' }}
      />

      {companyId && (
        <CompanyExportRendererToggles companyId={companyId} key={companyId} />
      )}
    </Box>
  );
}
